/**
 * @voltxampere/ui — J201 n-channel JFET variant (Sprint 38-3)
 *
 * Reference: Vishay/InterFET J201 datasheet (TO-92 low-noise audio
 * JFET — yaygın guitar FX pedal device).
 *   Vt0   = -1.5 V         (pinch-off, datasheet -0.3..-1.5 V)
 *   Beta  = 7.11e-4 A/V²   (= 2·IDSS/Vp² for IDSS ≈ 0.8 mA, |Vp| = 1.5)
 *   Lambda = 0.005 1/V
 *
 * Düşük V_P + düşük IDSS = audio low-power preamp ideali.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { jfet } from "../jfet.js";
export const jfetNJ201 = {
    id: "j201",
    nameTr: "J201 (JFET n-kanal audio, TO92)",
    nameEn: "J201 (n-channel audio JFET, TO92)",
    shortcut: "J",
    category: "active",
    viewBox: jfet.viewBox,
    terminals: jfet.terminals,
    defaultLabel: "J",
    defaultValue: "J201",
    schemaType: "jfet-n",
    defaultParams: { Vt0: -1.5, Beta: 7.11e-4, Lambda: 0.005 },
    renderSVG: () => jfet.renderSVG(),
};
//# sourceMappingURL=jfet-n-j201.js.map